/**
 * PURPOSE: Reaccionar en toda la app a una sesión Bearer que deja de valer (FTR-0019).
 * RESPONSIBILITIES: Escuchar el aviso de 401 de la API (token expirado/revocado) y el logout hecho
 *   en otra pestaña (evento storage) y, si esta pestaña tenía usuario, marcar la sesión como
 *   expirada en Redux y volver al login. No renderiza nada; debe vivir dentro del BrowserRouter.
 * COLLABORATORS: src/services/authToken.js, src/features/authSlice.js, src/App.js.
 * ROUTE: winscore/src/components/global/AuthSessionBridge.jsx
 */
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { sessionExpired } from "../../features/authSlice.js";
import { subscribeAuthTokenRemoved, subscribeUnauthorized } from "../../services/authToken.js";

const AuthSessionBridge = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const userRef = useRef(user);
  userRef.current = user;

  useEffect(() => {
    const expire = () => {
      if (!userRef.current) return;
      dispatch(sessionExpired());
      navigate("/", { replace: true });
    };
    const unsubscribeUnauthorized = subscribeUnauthorized(expire);
    const unsubscribeStorage = subscribeAuthTokenRemoved(expire);
    return () => {
      unsubscribeUnauthorized();
      unsubscribeStorage();
    };
  }, [dispatch, navigate]);

  return null;
};

export default AuthSessionBridge;
